import React from 'react';
import { useTheme } from 'styled-components';
import * as S from './CheckBox.styles';

interface CheckBoxProps {
  isChecked: boolean;
  onClick?: (a: boolean) => void;
  disabled?: boolean;
  invisibleWhenHidden?: boolean;
  small?: boolean;
  medium?: boolean;
  dataCy?: string;
}

const CheckBox: React.FC<CheckBoxProps> = ({
  isChecked,
  onClick,
  disabled,
  invisibleWhenHidden,
  small,
  medium,
  dataCy = 'checkbox',
}) => {
  const colors = useTheme().colors;
  return (
    <S.Div
      $isChecked={isChecked}
      onClick={onClick ? () => onClick(!isChecked) : undefined}
      $disabled={disabled}
      $invisibleWhenHidden={invisibleWhenHidden}
      $small={small}
      $medium={medium}
      data-cy={dataCy}
    >
      {isChecked && (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
          <g clipPath="url(#clip0_1795_3731)">
            <path
              d="M7.87563 14.1481L4.22688 10.4994L2.98438 11.7331L7.87563 16.6244L18.3756 6.12437L17.1419 4.89062L7.87563 14.1481Z"
              fill={colors.btnWhite}
            />
          </g>
          <defs>
            <clipPath id="clip0_1795_3731">
              <rect width="21" height="21" fill={colors.white} />
            </clipPath>
          </defs>
        </svg>
      )}
    </S.Div>
  );
};

export default CheckBox;
